<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<Header></Header>
		<div class="page_content">
			
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/tw/">首頁</a><span class="space">/</span>快捷檢索
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			
			<!--页面内容-开始-->
			<div class="faq_content">
				<!-- <div class="title">搜索结果</div> -->
				<div class="search_box">
					
					<!--搜索区-开始-->
					<div class="filter_box">
						<div class="elem">
							<el-input
							  placeholder="請輸入您感興趣的內容"
							  maxlength="100"
							  ref="keyword"
							  @keyup.enter.native="searchHandle"
							  v-model="keyword">
							</el-input>
						</div>
						<div class="elem">
							<el-tooltip class="item" effect="dark" :content="keyword==''?tips:'點擊開始檢索'" placement="bottom">
							<el-button type="primary" round icon="el-icon-search" @click="searchHandle()">檢索</el-button>
							</el-tooltip>
						</div>
					</div>
					<!--搜索区-开始-->
					<!--Tab区-开始-->
					<div class="tab_box">
						<ul>
							<li :class="columnId==item.Id?'selected':''" v-for="(item, index) in columnList" :key="index" @click="changeColumn(item.Id)">{{item.Title}}</li>
						</ul>
					</div>
					<!--Tab区-结束-->
					
					<!--搜索结果-开始-->
					<div class="result_box">
						
						<div class="item" v-for="(item, index) in dataList" :key="index">
							<h3><a :href="'/tw/'+item.Path+'/detail?Id='+item.Id" target="_blank">{{item.Title}}</a></h3>
							<div class="content">
								<div class="picture">
									<img :src="item.Picture" />
								</div>
								<div class="text">
									<p>{{truncatedMessage(item.SubTitle,240)}}</p>
									<div class="tag">{{item.ColumnTitle}}</div>
								</div>
							</div>
						</div>
						
						<!--无数据-->
						<NoData :isShow="noDataIsShow"></NoData>
						
					</div>
					<!--搜索结果-结束-->

					
					<!--分页-开始-->
					<div class="page_ctrl" v-if="dataList.length>0 && pageTotal>1">
						<el-pagination layout="prev, pager, next" :total="recordTotal" :current-page="pageIndex"
							:pager-count="5" :page-size="pageSize" :background="true" @current-change="handleCurrentChange">
						</el-pagination>
					</div>
					<!--分页-结束-->
					
				</div>
			</div>
			<!--页面内容-结束-->
		</div>
		<Footer></Footer>
	</div>
</template>


<script>
	import {
		getSearchList,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import moment from 'moment';
	import Header from '@/components/tw_header.vue'
	import Footer from '@/components/tw_footer.vue'
	import NoData from '@/components/tw_noData.vue'
	export default {
		name: 'CN_FaqPage',
		mixins: [mixin],
		components: {
			Header,
			Footer,
			NoData,
		},
		data() {
			return {
				fullscreenLoading: false, //loading状态
				noDataIsShow: false, //无数据缺省
				language: 'tw', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				
				keyword: '',
				tips: '請在左側輸入您感興趣的內容',
				columnId: 0,	//选中的栏目
				columnList: [],	//栏目列表
				
				pageIndex: 1, 		//页码，默认为1
				pageSize: 10, 		//每页显示条数
				pageTotal: 0, 		//总页数
				recordTotal: 0, 	//总条数
				
				dataList: [],		//数据列表
			}
		},
		created() {
			// 获取参数
			if (this.$route.query.keyword != undefined && this.$route.query.keyword != null && this.$route.query.keyword != '') {
				this.keyword = this.$route.query.keyword

				this.getData()
			}
		},
		methods: {
			//获取数据
			async getData() {
				this.fullscreenLoading = true
				this.dataList = []
				const { data: res } = await getSearchList(this.language, this.keyword, this.columnId, this.pageIndex)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.dataList = res.data.PageData.DataList
					this.columnList = res.data.ColumnList
					
					this.pageTotal = res.data.PageData.PageTotal
					this.recordTotal = res.data.PageData.RecordTotal
					if(this.dataList.length >0)
					{
						this.noDataIsShow = false
						this.$nextTick(() => {
							window.scrollTo(0, 0);
						});
					} else {
						this.noDataIsShow = true
					}
					
				} else {
					this.errMessage = res.errmsg
				}
			},
			//切换页码
			handleCurrentChange(val) {
				this.pageIndex = val
				this.getData()
			},
			//切换栏目
			changeColumn(Id)
			{
				if(this.columnId == Id)
				{
					return
				}
				this.columnId = Id
				this.pageIndex = 1
				this.getData()
			},
			keyEnter()
			{
				this.searchHandle()
			},
			//搜索
			searchHandle()
			{
				if(this.keyword == '')
				{
					this.$message.error("請輸入您感興趣的內容");
					this.$refs.keyword.focus()
					return
				}
				
				this.pageIndex = 1
				this.getData()
			}
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		.faq_content {
			margin-top: 40px;
		}
		
		.search_box {
			min-height: 600px;
			
			/*筛选*/
			.filter_box {
				display: flex;
				
				.elem {
					margin-right: 15px;
				}
			}
			
			/*标签*/
			.tab_box {
				margin-top: 20px;
				// padding-left: 8px;
				
				ul {
					display: flex;
					align-items: center;
					
					li {
						font-size: 13px;
						color: #333;
						height: 36px;
						line-height: 36px;
						font-weight: 400;
						padding: 0 15px;
						box-sizing: border-box;
						background-color: #f7f7f7;
						border-radius: 8px;
						margin-right: 12px;
						cursor: pointer;
					}
					li:hover {
						color: #3D7856;
					}
					li.selected {
						color: #3D7856;
						font-weight: 500;
					}
				}
			}
			
			/*搜索结果*/
			.result_box {
				width: 90%;
				margin-top: 30px;
				margin-bottom: 50px;
				
				.item {
					margin-top: 30px;
					
					h3 {
						font-size: 16px;
						font-weight: 500;
						
						a {
							color: #000;
							text-decoration: underline;
						}
						
						a:hover {
							color: #3D7856;
						}
					}
					
					.content {
						margin-top: 10px;
						display: flex;
						justify-content: space-between;
						
						.picture {
							width: 134px;
							
							img {
								width: 100%;
								border-radius: 5px;
								display: block;
							}
						}
						.text {
							width: 87.5%;
							position: relative;
							
							p {
								font-size: 13px;
								line-height: 160%;
								color: #666;
							}
							
							.tag {
								margin-top: 10px;
								font-size: 13px;
								color: #888;
							}
						}
					}
				}
			}
			
		}
		
		/deep/ .el-input {
			border: 0;
			border-radius: 8px;
		}
		/deep/ .el-input__inner {
			width: 600px;
			height: 42px;
			border: #c4c4c4 solid 1px;
			border-radius: 8px;
			background-image: none;
			font-weight: 400;
		}
		
		
		.el-button {
			width: 100%;
			font-family: "PingFang SC", sans-serif, Helvetica, Arial;
			font-size: 15px;
			font-weight: 400;
			height: 42px;
			border-radius: 21px;
			-webkit-transition: all .3s ease;
		}
		
		.el-button--primary {
			border: 0;
			border-radius: 8px;
		}		
		.el-button--primary:focus {
			background-color: #3D7856;
		}
		.el-button--primary:hover {
			background-color: #000;
		}
		
		
		
		
		/deep/ .el-pagination {
			font-size: 16px;
		}
		
		/deep/ .el-pager li {
			width: 36px;
			height: 36px;
			font-size: 16px;
			line-height: 36px;
			margin: 0 5px;
			border-radius: 5px;
		}
		
		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background-color: #3D7856;
			font-size: 16px;
		}
		
		/deep/ .el-pagination button {
			width: 36px;
			height: 36px;	
			border-radius: 5px;
		}
		
		/deep/ .el-pagination .btn-next .el-icon {
			font-size: 16px;
		}
		/deep/ .el-pagination .btn-prev .el-icon {			
			font-size: 16px;
		}
		
		
	}
</style>